export class YuipotaTokenResponse {
  token?: string

  constructor(token?:string) {
    this.token = token
  }
}
